// extracted by mini-css-extract-plugin
export default {"pre":"pre___O4pym"};